"use client";
import Link from "next/link";
import { useRouter } from "next/navigation";
import { Button } from "@wayak/ui/components/ui/button";
import { WayakAssets } from "@wayak/ui/components/wayak/wayak-logos";

export default function NotFound() {
  const router = useRouter();

  return (
    <main className="container mx-auto flex min-h-screen flex-col items-center justify-center gap-6 p-4 text-center">
      <WayakAssets.wayakLogoBlack className="w-32 h-32" />

      <h2 className="text-2xl font-semibold">Resource not found</h2>
      <p className="max-w-md text-muted-foreground">
        Sorry, we couldn’t find the page or resource you were looking for.
      </p>

      <div className="flex flex-wrap items-center justify-center gap-4">
        <Button variant="secondary" onClick={() => router.back()}>
          Go back to last place
        </Button>
        <Link href="/">
          <Button>Go back home</Button>
        </Link>
      </div>
    </main>
  );
}
